module.exports = __webpack_public_path__ + "static/media/newLogo.a247b4ce.svg";